<div [linaDisableAll]="disableFormControls">
  <lina-lina-loading></lina-lina-loading>
  <router-outlet></router-outlet>
</div>
